module.exports = __webpack_public_path__ + "static/img/error-img.c7ae99ce.png";